<template>
  <el-container>
    <el-main>
      <div class="jumbotron">
        <h1 class="display-4">{{ $t("unauthorized401.title") }}</h1>
        <p class="lead">
          {{ $t("unauthorized401.text") }}
        </p>
        <hr class="my-4" />
        <router-link
          class="btn btn-primar btn-lgy"
          :to="{ name: 'login', params: $route.params }"
          >{{ $t("unauthorized401.link") }}</router-link
        >
      </div>
    </el-main>
  </el-container>
</template>

<script>
export default {
  metaInfo () {
    return {
      title: this.$t('unauthorized401.metaTitle')
    }
  }
}
</script>
